import Categories from '@/Pages/MealPlanner/Categories';
import Recipes from '@/Pages/MealPlanner/Recipes';
import Banners from '@/Pages/MealPlanner/Banners';

const MealPlannerRoutes = [
  {
    breadcrumb: [{ path: '/meal-planner/banners', breadcrumbName: 'Meal Planner Banners' }],
    Component: Banners,
  },
  {
    breadcrumb: [{ path: '/meal-planner/categories', breadcrumbName: 'Meal Planner Categories' }],
    Component: Categories,
  },
  {
    breadcrumb: [{ path: '/meal-planner/recipes', breadcrumbName: 'Meal Planner Recipes' }],
    Component: Recipes,
  },
];

export default MealPlannerRoutes;
